export const Status = {
  Active: 'Active',
  Pending: 'Pending',
  Warning: 'Warning',
  Error: 'Error',
};
